import React from 'react';
import { observer, inject } from 'mobx-react';
import { Theme, Modal, Paper, Typography, Button } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import { ModalProps } from '@mui/material/Modal';
import { ButtonProps } from '@mui/material/Button';
import { WithTranslation, withTranslation } from 'react-i18next';

import { WizardModel } from '../../models/kiosk/WizardModel';
import { Billpay } from '../../models/kiosk/Billpay';
import { Services } from '../../helpers/constants/Services';
import { ReceiptStep } from '../../interfaces';
import { defaultStyle } from './CommonModalStyles';

type ModalWithoutChildrenProps = Omit<ModalProps, 'children'>;

interface ReceiptGeneratingErrorModalProps
    extends WithStyles<typeof styles>,
        WithTranslation {
    modalProps?: ModalWithoutChildrenProps;
    buttonProps?: ButtonProps;
}
interface ReceiptGeneratingErrorModalPropsInjected
    extends ReceiptGeneratingErrorModalProps {
    wizard: WizardModel;
    billpay: Billpay;
}

const styles = (theme: Theme) =>
    createStyles(defaultStyle);

@inject(Services.BILLPAY)
@observer
class ReceiptGeneratingErrorModal extends React.Component<
    ReceiptGeneratingErrorModalProps,
    any
> {
    get injected() {
        return this.props as ReceiptGeneratingErrorModalPropsInjected;
    }

    render() {
        const { modalProps, buttonProps, classes, t } = this.props;
        const { billpay } = this.injected;

        return (
            <Modal
                aria-labelledby='close-warning-title'
                aria-describedby='close-warning-description'
                open={false}
                {...modalProps}
            >
                <Paper className={classes.root}>
                    <div className={classes.header}>
                        <Typography variant='h3'>{t('Error')}</Typography>
                    </div>
                    <div className={classes.body}>
                        <Typography
                            variant='h4'
                            style={{ fontWeight: 'normal' }}
                        >
                            {billpay.receipts.step !== ReceiptStep.Email &&
                                t(
                                    'Something went wrong during generating receipt We can not print receipt right now therefore input your email address on next screen We will send email with receipt as soon as error will be resolved'
                                )}
                            {billpay.receipts.step === ReceiptStep.Email &&
                                t(
                                    'Something went wrong during generating receipt We can not email receipt right now We will send email with receipt as soon as error will be resolved'
                                )}
                        </Typography>
                    </div>

                    <div className={classes.footer}>
                        <Button
                            variant='primary'
                            style={{ width: 200 }}
                            {...buttonProps}
                        >
                            <Typography variant='button'>{t('OK')}</Typography>
                        </Button>
                    </div>
                </Paper>
            </Modal>
        );
    }
}

export default withTranslation()(
    withStyles(styles)(ReceiptGeneratingErrorModal)
);
